export const absUrl = (path: string) => {
  const langUrl = window.location.pathname.split('/')[1]
  return `/${langUrl}${path}`
}
